module.exports = __webpack_public_path__ + "static/img/fz_thb_ys.02507fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_thb_ys.png
// module id = L3WL
// module chunks = 0